export const ApplicationStatus = {
  'pending': 'Pending',
  'active': 'Active',
  'cancelled': 'Cancelled',
  'deceased': 'Deceased',
};

export const InputType = {
  TEXT: 'text',
  SELECT: 'select',
  DATE: 'date',
};

export const applicationKeysMap = {
  member_id: {label: "MemberID", editable: false },
  soc_sec_number: { label: "SSN", editable: true, type: InputType.TEXT, mask: true },
  first_name: { label: "First Name", editable: true, type: InputType.TEXT },
  middle_name: { label: "Middle Name", editable: true, type: InputType.TEXT },
  last_name: { label: "Last Name", editable: true, type: InputType.TEXT },
  phone: { label: "Phone", editable: true, type: InputType.TEXT },
  email_address: { label: "Email Address", editable: true, type: InputType.TEXT },
  gender: { label: "Gender", editable: true, type: InputType.SELECT, options: [
      { value: 'male', label: 'Male'},
      { value: 'female', label: 'Female'},
    ]},
  status: {
    label: "Status",
    editable: true,
    type: InputType.SELECT,
    options: [
      { value: 'pending', label: 'Pending' },
      { value: 'active', label: 'Active' },
      { value: 'cancelled', label: 'Cancelled' },
      { value: 'deceased', label: 'Deceased' },
    ]
  },
  balance: { label: "Remaining balance", editable: false },
  sales_agency: { label: "Sales Agency", editable: true, type: InputType.TEXT },
  membership_date: { label: 'Membership Date', editable: true, type: InputType.DATE },
  date_of_cancellation: { label: 'Date Of Cancellation', editable: true, type: InputType.DATE, clearable: true },
  date_of_birth: { label: "Date Of Birth", editable: true, type: InputType.DATE },
  deceased_date: { label: "Deceased Date", editable: true, type: InputType.DATE },
  date_of_claim: { label: "Date Of Claim", editable: true, type: InputType.DATE },
  address_1: { label: "Address 1", editable: true, type: InputType.TEXT },
  address_2: { label: "Address 2", editable: true, type: InputType.TEXT },
  city: { label: "City", editable: true, type: InputType.TEXT },
  state: { label: "State", editable: true, type: InputType.TEXT },
  postal_code: { label: "Postal Code", editable: true, type: InputType.TEXT },
  country: { label: "Country", editable: true, type: InputType.TEXT },
  service_agency: { label: "Service Agency", editable: true },
  insurance_agency: { label: "Insurance Agency", editable: true },
  insured_id_a: { label: "Insured ID A", editable: true, type: InputType.TEXT },
  lh_entered: { label: "LH Entered", editable: true, type: InputType.TEXT },
  record_id: { label: "Record ID", editable: true, type: InputType.TEXT },
  insured_id_b: { label: "Insured ID B", editable: true, type: InputType.TEXT },
  product: { label: "Product", editable: true, type: InputType.TEXT },
  producer_id: { label: "Producer ID", editable: true, type: InputType.TEXT },
  subproducer_id: { label: "Subproducer ID", editable: true, type: InputType.TEXT },
  contract_number: { label: "Contract Number", editable: true, type: InputType.TEXT },
  contract_date: { label: "Contract Date", editable: true, type: InputType.DATE },
  funeral_home: { label: "Funeral Home", editable: true, type: InputType.TEXT },
  funeral_home_id: { label: "Funeral Home ID", editable: true, type: InputType.TEXT },
  funeral_home_name: { label: "Funeral Home Name", editable: true, type: InputType.TEXT },
  funeral_home_city: { label: "Funeral Home City", editable: true, type: InputType.TEXT },
  funeral_home_state: { label: "Funeral Home State", editable: true, type: InputType.TEXT },
  note: { label: "Note", editable: true, type: InputType.TEXT },
  record_source: { label: "Record Source", editable: false, },
};

export const filters = {
  EQUAL: {label: 'IS', value: '='},
  NOT_EQUAL: {label: 'IS NOT', value: '!='},
  CONTAIN: {label: 'CONTAINS', value: '%'},
  MORE: {label: 'MORE THAN', value: '>='},
  LESS: {label: 'LESS THAN', value: '<='},
};

export const applicationFiltersMap = {
  first_name: { label: "First Name", type: InputType.TEXT, filters: [filters.EQUAL, filters.NOT_EQUAL, filters.CONTAIN]},
  last_name: { label: "Last Name", type: InputType.TEXT, filters: [filters.EQUAL, filters.NOT_EQUAL, filters.CONTAIN]},
  insurance_agency_id: {
    label: "Insurance Agency",
    type: InputType.SELECT,
    options: [],
    filters: [filters.EQUAL, filters.NOT_EQUAL]
  },
  service_agency_id: {
    label: "Service Agency",
    type: InputType.SELECT,
    options: [],
    filters: [filters.EQUAL, filters.NOT_EQUAL]
  },
  sales_agency: {
    label: "Sales Agency",
    type: InputType.TEXT,
    filters: [filters.EQUAL, filters.NOT_EQUAL, filters.CONTAIN]
  },
  status: {
    label: "Status",
    type: InputType.SELECT,
    options: [
      {value: 'pending', label: 'Pending'},
      {value: 'active', label: 'Active'},
      {value: 'cancelled', label: 'Cancelled'},
      {value: 'deceased', label: 'Deceased'},
    ],
    filters: [filters.EQUAL, filters.NOT_EQUAL],
  },
  city: { label: "City", type: InputType.TEXT, filters: [filters.EQUAL, filters.NOT_EQUAL, filters.CONTAIN]},
  member_id: {label: "MemberID", type: InputType.TEXT, filters: [filters.EQUAL, filters.NOT_EQUAL, filters.CONTAIN]},
  contract_number: {
    label: "Contract Number",
    type: InputType.TEXT,
    filters: [filters.EQUAL, filters.NOT_EQUAL, filters.CONTAIN],
  },
  soc_sec_number: {
    label: "SSN",
    type: InputType.TEXT,
    filters: [filters.EQUAL, filters.NOT_EQUAL, filters.CONTAIN],
  },
  email_address: {
    label: "Email Address",
    type: InputType.TEXT,
    filters: [filters.EQUAL, filters.NOT_EQUAL, filters.CONTAIN],
  },
  balance: {
    label: "Remaining balance",
    type: InputType.TEXT,
    filters: [filters.EQUAL, filters.MORE, filters.LESS],
  },
  membership_date: {
    label: 'Membership Date',
    type: InputType.DATE,
    filters: [filters.EQUAL, filters.NOT_EQUAL, filters.MORE, filters.LESS],
  },
  record_source: {
    label: 'Record Source',
    type: InputType.SELECT,
    options: [
      { value: 'api', label: 'API' },
      { value: 'portal-agency', label: 'Portal Agency' },
      { value: 'portal-direct', label: 'Portal Direct' },
      { value: 'datafile-portal', label: 'Portal Prepaid' },
      { value: 'datafile', label: 'Imported' },
    ],
    filters: [filters.EQUAL, filters.NOT_EQUAL]
  },
};
